export default __webpack_public_path__ + "static/head-nav-active-573d2743ec2f92ce4bce1d04e810f452.png";